import Vue from 'vue'
import { mapGetters } from 'vuex'
import Maintenance from '@/components/Maintenance.vue'

export function plainLayout (PageComponent) {
  return Vue.extend({
    inheritAttrs: false,
    components: {
      PageComponent,
      Maintenance
    },
    render () {
      return (
        <div id="app" class="plain">
          {
            this.isMaintenance ? <Maintenance /> : <PageComponent propsData={this.$attrs} />
          }
        </div>
      )
    },
    computed: {
      ...mapGetters([
        'maintenance'
      ]),
      isMaintenance () {
        return this.maintenance.status === 'on'
      }
    }
  })
}
